import { Checkbox, MenuItemComponentProps } from '@shape-ds/components';
import './NotificationsAssetLine.scss';
import { useOptimizedAssetSelection } from '../useOptimizedAssetSelection';

const NotificationAssetLine = ({ item, depth = 1, isOpen, setIsOpen }: MenuItemComponentProps) => {
  const { isSelected, isPartialSelected, toggleSelection } = useOptimizedAssetSelection(item);

  return (
    <Checkbox
      label={item.name}
      name={item.id}
      checked={isSelected}
      partialChecked={isPartialSelected}
      onChange={() => {
        toggleSelection();
        setIsOpen(true);
      }}
      className={`notification-asset-line-checkbox depth-${depth}`}
    />
  );
};

export default NotificationAssetLine;
